if (!customElements.get('tabbed-content')) {
  customElements.define(
    'tabbed-content',
    class TabbedContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-tab]');
        this.targets = this.querySelectorAll('[data-target]');

        if (!(this.tabs && this.targets)) return;

        this.bindEvents();
        this.setInitialState();
      }

      bindEvents() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const target = tab.dataset.tab;
            this.toggleTabs(target);
          });
        });
      }

      setInitialState() {
        const firstTab = this.tabs[0];
        if (firstTab) {
          this.toggleTabs(firstTab.dataset.tab);
        }
      }

      toggleTabs(target) {
        this.tabs.forEach((tab) => {
          tab.classList.toggle('is-selected', tab.dataset.tab === target);
        });

        this.targets.forEach((tabTarget) => {
          tabTarget.style.display = tabTarget.dataset.target === target ? 'block' : 'none';
        });
      }
    }
  );
}
